import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { getPhraseStatusInfo } from '../../service/PhrasesHelpers/PhrasesHelpers';
import { GdShowConditionPrimaryStatus } from '../../typings/graphql-grid';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';

import './PhraseStatusCell.css';

export interface PhraseStatusCellProps {
    status: GdShowConditionPrimaryStatus;
    isTextVisible: boolean;
}

const BLOCK = 'phrase-status-cell';

export class PhraseStatusCell extends React.PureComponent<PhraseStatusCellProps> {
    render() {
        const { status, isTextVisible } = this.props;
        const statusText = getPhraseStatusInfo(status);

        return (
            <div
                className={Bem.cls({
                    block: BLOCK,
                    mods: {
                        status: Bem.beminize(status)
                    }
                })}
            >
                {this.getStatusIcon()}
                {isTextVisible && statusText}
            </div>
        );
    }

    private getStatusIcon() {
        const { status } = this.props;
        const statusText = getPhraseStatusInfo(status);

        switch (status) {
            case GdShowConditionPrimaryStatus.ACTIVE:
                return (
                    <Shape2
                        icon={Shape2Icon.statusRunning}
                        theme={Shape2Theme.light}
                        width={12}
                        height={12}
                        cls={Bem.cls(BLOCK, 'icon')}
                        title={statusText}
                    />
                );
            case GdShowConditionPrimaryStatus.MODERATION_REJECTED:
                return (
                    <Shape2
                        icon={Shape2Icon.statusStopped}
                        theme={Shape2Theme.light}
                        width={12}
                        height={12}
                        cls={Bem.cls(BLOCK, 'icon')}
                        title={statusText}
                    />
                );
            case GdShowConditionPrimaryStatus.ARCHIVED:
                return (
                    <Shape2
                        icon={Shape2Icon.archived}
                        theme={Shape2Theme.light}
                        width={12}
                        height={12}
                        cls={Bem.cls(BLOCK, 'icon')}
                        title={statusText}
                    />
                );
            case GdShowConditionPrimaryStatus.STOPPED:
            case GdShowConditionPrimaryStatus.DRAFT:
            default:
                return (
                    <Shape2
                        icon={Shape2Icon.statusEnded}
                        theme={Shape2Theme.light}
                        width={12}
                        height={12}
                        cls={Bem.cls(BLOCK, 'icon')}
                        title={statusText}
                    />
                );
        }
    }
}
